import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { getCookies } from '../../utils/common';
import { RETRIEVE_BOOKING_BY_PROFILE } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { retrieveBookingsByProfile: bffResponse };
}

export default function useBookingsByProfile(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(RETRIEVE_BOOKING_BY_PROFILE, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables: { accessToken } = {} } = {}) =>
      restRequest({
        path: '/air-api/v1/bookings/by-profile',
        headers: { 'access-token': accessToken || getCookies('accessToken') },
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
